/// <reference path="../_references.ts"/>

module App.WorkOrder {
	angular
		.module('workOrder', [
			'ngFitText',
			'ngSanitize',
			'angularTrix',
			'helpers.signature',
		])
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
			$stateProvider.state('zipSolutions.workOrder', {
				url: 'work-order?deleted',
				data: {
					title: 'Work Order'
				},
				params: {
					deleted: {
						dynamic: true,
						type: 'string',
						value: '0',
						squash: true,
					},
				},
				views: {
					'content@': {
						controller: 'WorkOrderController',
						controllerAs: 'workOrder',
						templateUrl: 'html/work-order/work-order.html'
					}
				},
			});
		}])
		.service('BannerService', BannerService.Factory())
		.service('WorkOrderService', WorkOrderService.Factory())
		.service('PackageActionsService', PackageActionsService.Factory())
		.controller('WorkOrderController', WorkOrderController)
		.controller('BannerFlyoutController', BannerFlyoutController);
}
